import { defineComponent, onMounted, ref } from 'vue';
import VCResizeObserver from '../../vc-resize-observer';
const INTERNAL_KEY_PREFIX = 'RC_TABLE_KEY';
function toArray(arr) {
    if (arr === undefined || arr === null) {
        return [];
    }
    return (Array.isArray(arr) ? arr : [arr]);
}
function getColumnKey(item) {
    let mergedKey = item.key || toArray(item.dataIndex).join('-') || INTERNAL_KEY_PREFIX;
    return mergedKey;
}
export default defineComponent({
    name: 'MeasureCell',
    props: ['columnKey', 'columns'],
    setup(props, { emit }) {
        const tdRef = ref();
        onMounted(() => {
            if (tdRef.value) {
                const { width } = tdRef.value.getBoundingClientRect();
                // emit('columnResize', props.columnKey, tdRef.value.offsetWidth);
                emit('columnResize', props.columnKey, width);
            }
        });
        return () => {
            const filter = props.columns.find((item) => getColumnKey(item) === props.columnKey);
            const tdText = filter && filter.title && props.columnKey !== INTERNAL_KEY_PREFIX ? filter.title : '&nbsp;';
            return (<VCResizeObserver onResize={({ offsetWidth }) => {
                    emit('columnResize', props.columnKey, offsetWidth);
                }}>
          <td ref={tdRef} style={{ paddingTop: 0, paddingBottom: 0, border: 0, height: 0, fontWeight: 600 }}>
            <div style={{ height: 0, overflow: 'hidden' }}>{tdText}</div>
          </td>
        </VCResizeObserver>);
        };
    },
});
